<template>
  <b-modal
    centered
    scrollable
    size="lg"
    :id="id"
    :title="$t('dharma-application-form.application-list.title')"
  >
    <application-list ref="application_list"></application-list>
    <template #modal-footer="{ close }">
      <b-button class="w-50" variant="default" @click="close()">
        <span
          style="word-break: break-word; white-space: normal; overflow-wrap: break-word;"
          class="d-block d-sm-inline-block"
          v-html="$t('modal.button.continue-browsing.label')"
        ></span>
      </b-button>
      <b-button
        class="w-50"
        variant="success"
        @click="submit"
      >{{ $t('modal.button.submit.label') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import ApplicationList from '../ApplicationList';

export default {
  name: 'ApplicationListModal',
  components: {
    ApplicationList,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    async submit() {
      const application_list = this.$refs.application_list
      const form_validation_result = await application_list.validateForm()

      if (form_validation_result) {
        this.$emit('submit', {
          items: application_list.items,
          purpose: application_list.purpose,
          purpose_detail: application_list.purpose_detail,
        })
      }
    }
  },
};
</script>
